import { render, staticRenderFns } from "./Webshops.vue?vue&type=template&id=e313a66e&scoped=true&"
import script from "./Webshops.vue?vue&type=script&lang=js&"
export * from "./Webshops.vue?vue&type=script&lang=js&"
import style0 from "./Webshops.vue?vue&type=style&index=0&id=e313a66e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e313a66e",
  null
  
)

export default component.exports